import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';
import { NgProgressbar } from 'ngx-progressbar';
import { NgProgressHttp } from 'ngx-progressbar/http';
import { ToasterComponent, ToasterPlacement } from '@coreui/angular';
import { NgClass } from '@angular/common';
import { MainService } from './services/main.service';

@Component({
  selector: 'app-root',
  template: `<ng-progress ngProgressHttp speed="400"/>
              <router-outlet />
              <c-toaster [ngClass]="'p-3'" position="fixed" [placement]="position" />`,
  standalone: true,
  imports: [RouterOutlet,NgProgressbar, NgProgressHttp, ToasterComponent, NgClass]
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'Speedkdo Entreprise';
  position = ToasterPlacement.TopEnd;
  mainService = inject(MainService);
  @ViewChild(ToasterComponent) toasterInstance!: ToasterComponent
  constructor(
    private router: Router,
    private titleService: Title,
    private iconSetService: IconSetService
  ) {
    this.titleService.setTitle(this.title);
    // iconSet singleton
    this.iconSetService.icons = { ...iconSubset };
  }
  ngAfterViewInit(): void {
    this.mainService.setToaster(this.toasterInstance);
  }

  ngOnInit(): void {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    });
  }
}
